import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import { Skeleton } from "@mui/material";
import TextField2 from "../textfields/TextField2.js";
import { useSnackbar } from "notistack";
import { useAppContext } from "../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
} from "../models/DataFunctions.js";

import getTemporaryUrl from "../api/getTemporaryUrl.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import sendErrorDiscord from "../api/sendErrorDiscord.js";
import moment from "moment";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import Icon1 from "../icons/Icon.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import CurrencyField from "../textfields/CurrencyField.js";
import SmallSpinner from "../loading/SmallSpinner.js";

import PDF from "../pdf/PDF.js";
import { EasySwitch, ToggleSettingsBrick } from "../textfields/EasySwitch.js";
import { set } from "date-fns";
import getTemporaryUrlV2 from "../api/getTemporaryUrlV2.js";

function AiExtractionInvoice({
  folderData,
  navigateWorkspace,
  forcePageReload,
  onClose,
  orgData,
  userData,
}) {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [documents, setDocuments] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const [step, setStep] = useState(0);
  const [sources, setSources] = useState([]);
  const [comparedSources, setComparedSources] = useState(null);
  const [selectedSource, setSelectedSource] = useState({});
  const [displayExcel, setDisplayExcel] = useState(false);
  const [loadinFetch, setLoadingFetch] = useState(true);
  const [chrono, setChrono] = useState(0);

  const handleFetchData = async () => {
    if (orgData) {
      try {
        console.log("Fetching documents for folder:", folderData);
        const token = await getOrRefreshFirebaseToken();
        await getTemporaryUrl(token, "all", null, folderData.id, prefix);
        let documents = await getArrayDocDataByRef(folderData.documents);
        setDocuments(documents);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoadingFetch(false);
    }
  };

  const handleGenerateExcel = async () => {
    if (sources.length < 2) {
      handleClickVariant(
        "Veuillez sélectionner au moins deux sources pour générer le fichier excel",
        "error"
      );
      return;
    }
    // the endpoint is prefix + excel/create-excel
    // body is folder_id, rows, columns, file_name
    setLoadingFetch(true);
    let url = prefix + "excel/create-excel";
    let comparative_table = generateComparaisonTable(comparedSources);
    let file_name = `comparatif_${moment().format("DDMMYY_HHmmss")}.xlsx`;
    // use classic fetch, not formatData
    const token = await getOrRefreshFirebaseToken();
    const body = {
      folder_id: folderData.id,
      columns: [
        "source",
        "libelle",
        "devis_quantity",
        "facture_quantity",
        "unit",
        "unit_price",
        "amount",
        "progression",
      ],
      column_widths: [20, 40, 30, 15, 10, 20, 20, 10],
      rows: comparative_table.map((item) => ({
        data: [
          item.source,
          item.libelle,
          item.devis_quantity,
          item.facture_quantity,
          item.unit,
          item.unit_price,
          item.amount,
          item.progression,
        ],
        backgroundColor:
          item.background === "red"
            ? "#ffcccc"
            : item.background === "yellow"
              ? "#feffb4"
              : "#ffffff",
      })),

      file_name: file_name,
    };
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    const data = await response.json();
    if (data.error) {
      handleClickVariant(data.error, "error");
      setLoadingFetch(false);
      return;
    }
    if (data.url) {
      // open the file in a new tab
      window.open(data.url, "_blank");

      handleClickVariant("Fichier excel généré avec succès", "success");
      setLoadingFetch(false);
      return;
    } else {
      handleClickVariant(
        "Erreur lors de la génération du fichier excel",
        "error"
      );
      setLoadingFetch(false);
      return;
    }
  };
  const [loadingExtracting, setLoadingExtracting] = useState(false);
  const [saved_json, setSavedJson] = useState([]);

  
  const handleExtractSource = async () => {
    setLoadingExtracting(true);
    setChrono(0);
    // use formData to send to the api the selected source
    // refresh file url
    let fileInfo = sources.find(
      (s) => s.libelle === selectedSource?.libelle
    )?.file;
    let file_id = fileInfo?.id;
    if (!file_id) {
      handleClickVariant("Erreur lors de la récupération du fichier", "error");
      setLoadingExtracting(false);
      return;
    }
    const token = await getOrRefreshFirebaseToken();
    let fresh_url = await getTemporaryUrlV2(file_id, token, prefix);

    console.log("File info:", fileInfo);
    let file_url = fresh_url;
    let file_name = fileInfo.name;
    // download the file from the url
    let response_file = await fetch(file_url);
    let blob = await response_file.blob();

    let file = new File([blob], file_name, { type: blob.type });

    let url = prefix + "ai-extraction-invoice/extract-line-items-v2";
    const formData = new FormData();

    formData.append("file", file);

    const response = await fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Bearer " + (await getOrRefreshFirebaseToken()),
      },
    });

    const data = await response.json();
    if (data.error) {
      handleClickVariant(data.error, "error");
      setLoadingExtracting(false);
      return;
    }
    if (data.line_items) {
      let new_sources = sources.map((s) => {
        if (s.libelle === selectedSource?.libelle) {
          return {
            ...s,
            line_items: data.line_items,
          };
        } else {
          return s;
        }
      });
      setSources(new_sources);
      setSelectedSource({
        ...selectedSource,
        line_items: data.line_items,
      });

      handleClickVariant("Données extraites avec succès", "success");
    } else {
      handleClickVariant("Erreur lors de l'extraction des données", "error");
    }
    setLoadingExtracting(false);
  };

  useEffect(() => {
    handleFetchData();
  }, [orgData]);

  useEffect(() => {
    let interval = null;
    if (loadingExtracting) {
      interval = setInterval(() => {
        setChrono((prev) => prev + 1);
      }, 1000);
    } else if (!loadingExtracting && chrono !== 0) {
      clearInterval(interval);
      setChrono(0);
    }
    return () => clearInterval(interval);
  }, [loadingExtracting, chrono]);

  return (
    <div className="flex flex-col  bg-white rounded-3xl   w-full max-w-c1p2k h-fit overflow-auto max-h-c600">
      <div className="flex text-h3 justify-between items-center p-4 border-b border-neutral-200">
        <div className="">Extraction IA</div>
        <div className="text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>
      {step === 0 && (
        <>
          <div className="flex flex-col gap-2 p-4 bg-neutral-50">
            <div className="w-c300 text-h3 text-shadow_50">
              Sélectionnez les sources de données pour générer un excel
              comparatif
            </div>

            <div className="flex flex-col gap-2 max-h-c300 overflow-auto">
              {documents.map((doc, index) => (
                <div key={index}>
                  {doc?.files?.map((docFile, docIndex) => (
                    <div
                      key={docIndex}
                      className={`
                      ${
                        sources.map((s) => s.libelle).includes(docFile.name)
                          ? "bg-indigo-50"
                          : "hover:bg-indigo-50"
                      }
                      flex flex-row items-center pr-4 text-h3 p-2 rounded-xl`}
                    >
                      <div
                        className={`
              bg-gradient-to-tr from-indigo-300 to-indigo-100 
                  p-1 h-fit w-fit  rounded-2xl `}
                      >
                        <div
                          className="rounded-xl h-c75 w-14  bg-white   cursor-pointer flex items-center
               justify-center"
                        >
                          <Icon1
                            icon_name={
                              docFile?.name.includes("pdf")
                                ? "file"
                                : docFile?.name.includes("xml")
                                  ? "code"
                                  : "file"
                            }
                            size={25}
                            fill="#a5b4fc"
                            className="text-indigo-300 "
                          />
                        </div>{" "}
                      </div>
                      <div className="flex flex-col ml-4">
                        <div className=" mt-2">{docFile.name}</div>
                        <div className=" text-neutral-400">
                          {Math.round(docFile.octets / 1024)} Ko
                        </div>
                      </div>
                      <div className="ml-auto">
                        <CheckBoxGrey
                          checked={sources
                            .map((s) => s.libelle)
                            .includes(docFile.name)}
                          onChange={() => {
                            if (
                              sources
                                .map((s) => s.libelle)
                                .includes(docFile.name)
                            ) {
                              setSources(
                                sources.filter(
                                  (s) => s.libelle !== docFile.name
                                )
                              );
                            } else {
                              let new_source = {
                                libelle: docFile.name,
                                file: {
                                  name: docFile.name,
                                  size: `${Math.round(
                                    docFile.octets / 1024
                                  )} Ko`,
                                  url: docFile.url,
                                  id: docFile.id,

                                  type: docFile.contentType,
                                },
                                // line_items: docFile.name.includes("DEVIS")
                                //   ? default_items
                                //   : default_items2,
                                line_items: [],
                              };
                              setSources([...sources, new_source]);
                              setSelectedSource(new_source);
                            }
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-row  justify-end p-4 border-t-1">
            <PrimaryButton className={"w-fit"} onClick={() => setStep(1)}>
              Continuer
            </PrimaryButton>
          </div>
        </>
      )}
      {step === 1 && (
        <>
          <div className="flex flex-row ">
            <div className="flex flex-col gap-2  border-r-1 p-2 bg-neutral-50 ">
              {sources.map((item, index) => (
                <div
                  onClick={() => {
                    setSelectedSource(item);
                    setDisplayExcel(false);
                  }}
                  key={index}
                  className={`flex flex-row text-h4  
                
                cursor-pointer rounded-xl p-2
            ${item.libelle === selectedSource?.libelle ? " bg-indigo-100  " : "hover:bg-indigo-50"}
            `}
                >
                  <div
                    className={`
              bg-gradient-to-tr from-indigo-300 to-indigo-100
                 p-1 h-fit w-fit  rounded-2xl `}
                  >
                    <div
                      className="rounded-xl h-c75 w-16  bg-white   cursor-pointer flex items-center
               justify-center"
                    >
                      <Icon1
                        icon_name="file"
                        size={25}
                        fill="#a5b4fc"
                        className="text-indigo-300 text-h2"
                      />
                    </div>{" "}
                  </div>
                  <div className="flex flex-col ml-4 w-40">
                    <div className=" mt-2">{item.libelle.substring(0, 20)}</div>
                    <div className=" text-neutral-400">
                      {item.file.name.includes(".pdf")
                        ? "Fichier PDF"
                        : item.file.name.includes(".xml")
                          ? "Fichier XML"
                          : "Fichier"}{" "}
                      - {item.file.size}
                    </div>{" "}
                    <div className="text-indigo-400 text-h4">{`${calculateTotalProgression(item)}%`}</div>
                    <div className="w-40 h-1 bg-white rounded-full mt-2">
                      <div
                        className="h-1 bg-indigo-400 rounded-full"
                        style={{
                          width: `${calculateTotalProgression(item)}%`,
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="w-full pl-7 flex flex-row  items-center">
                <Icon1 icon_name="down" fill="grey" size={25} />
              </div>
              <div
                onClick={() => {
                  setDisplayExcel(true);
                  setSelectedSource(null);
                }}
                className={`
          ${displayExcel && !selectedSource ? " bg-indigo-100  " : "hover:bg-indigo-50"}
          flex flex-row text-h4 p-2 rounded-xl cursor-pointer  `}
              >
                <div
                  className={`
               
                bg-gradient-to-tr from-green-500 to-green-100 p-1 h-fit w-fit rounded-2xl `}
                >
                  <div
                    className="rounded-xl h-c75 w-16  bg-white   flex items-center
               justify-center"
                  >
                    <Icon1
                      icon_name="excel"
                      size={25}
                      fill="#a5b4fc"
                      className="text-indigo-300 text-h2"
                    />
                  </div>{" "}
                </div>
                <div className="flex flex-col ml-4 w-40">
                  <div className=" mt-2">{"Fichier excel"}</div>
                  <div className=" text-neutral-400">
                    Le fichier excel comparatif sera généré
                  </div>
                </div>
              </div>
            </div>
            {!displayExcel && selectedSource?.libelle && (
              <div className="flex flex-col gap-4  bg-neutral-100 p-4 overflow-auto max-h-c400 w-full">
                <div className="text-h3 mb-2 flex flex-row gap-2 items-center justify-between">
                  Données extraites {selectedSource?.line_items?.length}
                </div>
                <div className="flex flex-col rounded-xl border">
                  {selectedSource?.line_items?.map((item, index) => (
                    <div
                      key={index}
                      className="flex flex-row text-h5 w-full px-2 py-0.5 border-b-1"
                    >
                      <div className="flex flex-row justify-between w-full">
                        <div className="  w-6 text-indigo-300">
                          {selectedSource.line_items.indexOf(item)}
                        </div>
                        <div className="  w-c300">{item.libelle}</div>
                        <div className="flex flex-row gap-2 justify-start">
                          <div className="text-body text-neutral-400 italic w-10">
                            {item.devis_quantity}
                          </div>
                          <div className="text-body text-neutral-400 italic w-10">
                            {item.unit}
                          </div>
                          <div className="text-body text-neutral-400 italic w-16">
                            {item.unit_price}
                          </div>
                          <div className="text-body text-neutral-400 italic w-10">
                            {item.facture_quantity}
                          </div>
                          <div className="text-body text-neutral-400 italic w-16">
                            {item.amount}
                          </div>
                          <div
                            className={`
                          ${item.progression !== "0%" ? "text-indigo-500" : "text-neutral-300"}
                          text-body  italic w-10`}
                          >
                            {item.progression}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {displayExcel && !selectedSource && (
              <div className="flex flex-col gap-4  bg-neutral-100 p-4 overflow-auto max-h-c400 w-full">
                <div className="text-h3 mb-2 flex flex-row gap-2 items-center justify-between">
                  Comparaison des données
                </div>
                <div className="flex flex-row gap-4 text-h4 text-indigo-500 items-center">
                  {sources.map((s, index) => (
                    <div
                      key={index}
                      className="flex flex-row gap-2 items-center"
                    >
                      <CheckBoxGrey
                        checked={comparedSources
                          ?.map((cs) => cs.libelle)
                          .includes(s.libelle)}
                        onChange={() => {
                          if (
                            comparedSources
                              ?.map((cs) => cs.libelle)
                              .includes(s.libelle)
                          ) {
                            setComparedSources(
                              comparedSources.filter(
                                (cs) => cs.libelle !== s.libelle
                              )
                            );
                          } else {
                            let new_compared_sources = comparedSources
                              ? [...comparedSources, s]
                              : [s];
                            if (new_compared_sources.length > 2) {
                              new_compared_sources.shift(); // remove the first one to keep only 2
                            }
                            setComparedSources(new_compared_sources);
                          }
                        }}
                      />

                      <div className="">{s.libelle.substring(0, 15)}</div>
                    </div>
                  ))}
                </div>
                <div className="flex flex-col rounded-xl border">
                  {generateComparaisonTable(comparedSources)
                    .sort((a, b) => a.index - b.index)
                    .map((item, index) => (
                      <div
                        key={index}
                        className={`flex flex-row text-h5 w-full px-2 py-0.5 border-b-1
                      ${
                        item.background === "green"
                          ? ""
                          : item.background === "red"
                            ? "bg-red-100"
                            : item.background === "yellow"
                              ? "bg-yellow-100"
                              : "bg-white"
                      }
                      `}
                      >
                        <div className="flex flex-row  w-full">
                          <div className=" text-indigo-400 w-24">
                            {item.source?.substring(0, 10)}
                          </div>
                          <div className="w-6 text-indigo-300">
                            {item.index}
                          </div>
                          <div className=" w-c250 min-w-c250">
                            {item.libelle}
                          </div>
                          <div className="flex flex-row  justify-start">
                            <div className="text-body text-neutral-400 italic w-12">
                              {item.devis_quantity}
                            </div>
                            <div className="text-body text-neutral-400 italic w-10">
                              {item.unit}
                            </div>
                            <div className="text-body text-neutral-400 italic w-20">
                              {item.unit_price}
                            </div>
                            <div className="text-body text-neutral-400 italic w-12">
                              {item.facture_quantity}
                            </div>
                            <div className="text-body text-neutral-400 italic w-20">
                              {item.amount}
                            </div>
                            <div
                              className={`
                          ${item.progression !== "0%" ? "text-indigo-500" : "text-neutral-300"}
                          text-body  italic w-6`}
                            >
                              {item.progression}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-row  gap-2 p-4 border-t-1">
            <div className="flex flex-wrap w-c400 gap-2 mr-auto items-center">
              {saved_json.map((s, index) => (
                <div
                  onClick={() => {
                    //copy to clipboard
                    navigator.clipboard.writeText(JSON.stringify(s.line_items));
                    handleClickVariant(
                      "Données copiées dans le presse-papier",
                      "success"
                    );
                  }}
                  key={index}
                  className="bg-indigo-50 cursor-pointer text-indigo-500 rounded-full px-4 py-1 text-h5"
                >
                  {s.name} ({s.line_items.length})
                </div>
              ))}
            </div>
            <SecondaryButton className={"w-fit "} onClick={() => setStep(0)}>
              Retour
            </SecondaryButton>
            {displayExcel && !selectedSource && (
              <PrimaryButton className={"w-fit"} onClick={handleGenerateExcel}>
                Générer le fichier excel <SmallSpinner loading={loadinFetch} />
              </PrimaryButton>
            )}

            {!displayExcel && selectedSource && (
              <PrimaryButton className={"w-fit"} onClick={handleExtractSource}>
                Extraire les données{" "}
                <SmallSpinner loading={loadingExtracting} />{" "}
                {loadingExtracting ? `(${chrono}s)` : ""}
              </PrimaryButton>
            )}
            <PrimaryButton
              className={"w-fit"}
              onClick={() =>
                setSavedJson([
                  ...saved_json,
                  {
                    name: `s_${moment().format("HHmmss")}`,

                    line_items: selectedSource?.line_items,
                  },
                ])
              }
            >
              Sauvegarder les données
            </PrimaryButton>
          </div>
        </>
      )}
    </div>
  );
}

export default AiExtractionInvoice;
export function rounded(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}
export function calculateTotalProgression(source) {
  if (!source || !source.line_items || source.line_items.length === 0) {
    return 0;
  }
  const totalProgression = source.line_items.reduce((total, item) => {
    const progressionValue = parseFloat(item.progression) || 0;
    return rounded(total + progressionValue);
  }, 0);
  return rounded(totalProgression / source.line_items.length);
}
export function clean(text) {
  // to lower case and remove spaces
  return text.toLowerCase().replace(/\s/g, "");
}
export function cleanFloat(text) {
  // convert 1.00 and 1,00 to 1.0
  // convert 37 500,00 € to 37500.0
  return parseFloat(
    text
      .replace("€", "")
      .replace(/\s/g, "")
      .replace(",", ".")
      .replace(/[^0-9.]/g, "")
  );
}

export function compareLibelle(item1, item2) {
  // compare the libelle of two line items
  // return true if they are similar enough (like 50% of the characters are the same
  let libelle1 = clean(item1.libelle);
  let libelle2 = clean(item2.libelle);
  if (libelle1.length === 0 || libelle2.length === 0) {
    return false;
  }
  let sameChars = 0;
  for (let i = 0; i < Math.min(libelle1.length, libelle2.length); i++) {
    if (libelle1[i] === libelle2[i]) {
      sameChars++;
    }
  }
  let similarity = sameChars / Math.max(libelle1.length, libelle2.length);
  return similarity >= 0.5;
}

export function compareDevisQuantity(item1, item2) {
  // if no devis quantity, return true
  if (!item1.devis_quantity || !item2.devis_quantity) {
    return true;
  }
  return cleanFloat(item1.devis_quantity) === cleanFloat(item2.devis_quantity);
}

export function generateComparaisonTable(comparedSources) {
  // we are compariing the line items of each source
  // if a line item is identical in both, it should appear once with a green background
  // if a line item is different, it should appear twice with a red background with the differences highlighted
  // if a line item is only in one source, it should appear once with a yellow background
  if (!comparedSources || comparedSources.length < 2) {
    return [];
  }
  let source_1 = comparedSources[0];
  let source_2 = comparedSources[1];

  source_1 = {
    ...source_1,
    line_items: source_1.line_items.map((item) => formatLineItem(item)),
  };
  source_2 = {
    ...source_2,
    line_items: source_2.line_items.map((item) => formatLineItem(item)),
  };

  let table = [];
  source_1.line_items.forEach((item_1) => {
    let found = false;
    source_2.line_items.forEach((item_2) => {
      // compare indexes
      let index_1 = source_1.line_items.indexOf(item_1);
      let index_2 = source_2.line_items.indexOf(item_2);
      if (index_1 === index_2) {
        // same libelle, compare the rest

        found = true;
        if (
          compareDevisQuantity(item_1, item_2) &&
          cleanFloat(item_1.unit_price) === cleanFloat(item_2.unit_price)
        ) {
          table.push({
            ...item_1,
            background: "green",
            progression: item_2.progression,
            index: index_1,
          });
        } else {
          table.push({
            ...item_1,
            background: "red",

            source: source_1.libelle,
            index: index_1,
          });
          table.push({
            ...item_2,
            background: "red",
            source: source_2.libelle,
            index: index_2,
          });
        }
      }
    });
    if (!found) {
      table.push({
        ...item_1,
        background: "yellow",
        source: source_1.libelle,
        index: source_1.line_items.indexOf(item_1),
      });
    }
  });
  source_2.line_items.forEach((item_2) => {
    let found = false;
    source_1.line_items.forEach((item_1) => {
      let index_1 = source_1.line_items.indexOf(item_1);
      let index_2 = source_2.line_items.indexOf(item_2);
      if (index_1 === index_2) {
        found = true;
      }
    });
    if (!found) {
      table.push({
        ...item_2,
        background: "yellow",
        source: source_2.libelle,
        index: source_2.line_items.indexOf(item_2),
      });
    }
  });
  return table;
}
export function formatLineItem(item) {
  const parseLocalizedNumber = (value) => {
    if (typeof value === "number") return value;
    if (typeof value !== "string") return 0;

    // Remove currency symbols and clean up
    let cleaned = value.replace(/[€\s]/g, "");

    // Handle French number format: replace comma with dot for decimal
    // But we need to distinguish between thousands separator and decimal separator
    // In French format, the last comma is usually the decimal separator
    const lastCommaIndex = cleaned.lastIndexOf(",");
    if (lastCommaIndex !== -1) {
      // If there are digits after the last comma (decimal part)
      const afterComma = cleaned.substring(lastCommaIndex + 1);
      if (afterComma.length <= 3 && /^\d+$/.test(afterComma)) {
        // This comma is likely a decimal separator
        cleaned = cleaned.substring(0, lastCommaIndex) + "." + afterComma;
      }
    }

    // Remove any remaining commas (thousands separators)
    cleaned = cleaned.replace(/,/g, "");

    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  };

  return {
    ...item,
    devis_quantity: parseLocalizedNumber(item.devis_quantity).toFixed(2),
    facture_quantity: parseLocalizedNumber(item.facture_quantity).toFixed(2),
    unit_price: parseLocalizedNumber(item.unit_price).toLocaleString("fr-FR", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    amount: parseLocalizedNumber(item.amount).toLocaleString("fr-FR", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    progression: item.progression || "0%",
  };
}
